import React, { useState, useEffect } from 'react';
import { getCurrentApiUrl } from '../utils/api';

/**
 * API Config Display Component
 * Shows current API URL for debugging
 * Only visible in development or when explicitly enabled
 */
const ApiConfigDisplay = ({ alwaysShow = false }) => {
  const [apiUrl, setApiUrl] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const url = getCurrentApiUrl();
    setApiUrl(url || 'Relative URLs (same origin)');
    
    // Show in development or when explicitly enabled
    if (process.env.NODE_ENV === 'development' || alwaysShow) {
      setIsVisible(true);
    }
  }, [alwaysShow]);

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '10px',
      right: '10px',
      background: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      padding: '8px 12px',
      borderRadius: '6px',
      fontSize: '11px',
      zIndex: 9999,
      fontFamily: 'monospace',
      boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
    }}>
      <div style={{ marginBottom: '4px', opacity: 0.7 }}>🌐 API URL:</div>
      <div style={{ fontWeight: 'bold', color: '#4ade80' }}>{apiUrl}</div>
      <div style={{ marginTop: '4px', fontSize: '10px', opacity: 0.6 }}>
        {process.env.NODE_ENV === 'development' ? 'Development' : 'Production'}
      </div>
    </div>
  );
};

export default ApiConfigDisplay;
